import script from "./BikefittingLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BikefittingLayout.vue?vue&type=script&setup=true&lang=ts"

import "./BikefittingLayout.vue?vue&type=style&index=0&id=35aa6dc0&lang=scss"

const __exports__ = script;

export default __exports__